<script>
	export let name;
	export let text;
</script>

<style>
	h1 {
		color: purple;
	}
</style>

<h1>Hello {name}!!!</h1>
<p>{text}</p>
